import styled from 'styled-components'
import FormField from '../components/Molecules/FormField/FormField'

export const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	display: grid;
	grid-template-columns: 0.7fr 1.3fr;
	grid-gap: 30px;
	padding: 30px;
`

export const FormWrapper = styled.form`
	padding: 40px;
	background: ${({ theme }) => theme.colors.white};
	border-radius: 25px;
	width: 100%;
	height: 547px;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
`

export const StyledFormField = styled(FormField)`
	height: ${({ isTextarea }) => (isTextarea ? '300px' : 'unset')};
`

export const NotesWrapper = styled.div`
	padding: 20px 60px;
	display: flex;
	flex-direction: column;
`
